// Utility to check build version and clear localStorage if needed
const DB_NAME = "tazej";

export async function checkAndClearLocalStorageOnBuildChange() {
  try {
    const res = await fetch('/build-version.json', { cache: 'no-store' });
    const { version: currentVersion } = await res.json();
    const storedVersion = localStorage.getItem('build-version');
    if (storedVersion !== currentVersion) {
      localStorage.clear();
      localStorage.setItem('build-version', currentVersion);
      indexedDB.deleteDatabase(DB_NAME);
    }
  } catch (e) {
    // Optionally handle error
    console.warn('Could not check build version:', e);
  }
}
